export const UtilConvertTimeStampToDate = (timestamp) => {
  const date = new Date(timestamp * 1000); // Convert timestamp to milliseconds
  return date.toISOString().split('T')[0];
};
